<!-- Flat: it sits inside the list's card, like the client portal's alerts filter -->
<mat-expansion-panel class="mat-elevation-z0">
  <mat-expansion-panel-header>
    <mat-panel-title class="bold">
      {{ 'common.labels.filters' | transloco }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="_filterForm" class="padding">
    <div class="flex-container">
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.corporation' | transloco }}</mat-label>
        <mat-select formControlName="corporationID" [canSelectNullableOptions]="true" data-testid="alerts-filter-corporation">
          <mat-option [value]="null">{{ 'common.labels.any' | transloco }}</mat-option>
          @for (option of corporations; track option.value) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.alertType' | transloco }}</mat-label>
        <mat-select formControlName="alertTypes" multiple data-testid="alerts-filter-type">
          @for (option of alertTypes; track option.value) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.severity' | transloco }}</mat-label>
        <mat-select formControlName="alertSeverities" multiple data-testid="alerts-filter-severity">
          @for (option of alertSeverities; track option.value) {
            <mat-option [value]="option.value">{{ option.value | enumLabel:'alertSeverity' }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.status' | transloco }}</mat-label>
        <mat-select formControlName="alertStatuses" multiple data-testid="alerts-filter-status">
          @for (option of alertStatuses; track option.value) {
            <mat-option [value]="option.value">{{ option.value | enumLabel:'alertStatus' }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <!-- Alert ID (exact match, e.g. read out by a client from their alert page), then Tracked Item: pick a type,
         then filter on that type's details (partial matches) -->
    <div class="flex-container">
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.alertId' | transloco }}</mat-label>
        <input matInput formControlName="alertID" data-testid="alerts-filter-alert-id">
        <mat-error>{{ 'common.labels.enterTheFullAlertId' | transloco }}</mat-error>
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.trackedItem' | transloco }}</mat-label>
        <mat-select formControlName="trackedAlertEntityTypeID" [canSelectNullableOptions]="true" data-testid="alerts-filter-tracked-item">
          <mat-option [value]="null">{{ 'common.labels.any' | transloco }}</mat-option>
          @for (option of trackedItemTypes; track option.value) {
            <mat-option [value]="option.value">{{ option.value | enumLabel:'trackedAlertTypeEntity' }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @switch (trackedItemType) {
        @case (eTrackedAlertTypeEntity.SerialNumber) {
          <mat-form-field class="form-field flex-item">
            <mat-label>{{ 'common.labels.serialNumber' | transloco }}</mat-label>
            <input matInput formControlName="serialNumber" data-testid="alerts-filter-serial-number">
          </mat-form-field>
        }
        @case (eTrackedAlertTypeEntity.Individual) {
          <mat-form-field class="form-field flex-item">
            <mat-label>{{ 'common.labels.firstName' | transloco }}</mat-label>
            <input matInput formControlName="firstName" data-testid="alerts-filter-first-name">
          </mat-form-field>
          <mat-form-field class="form-field flex-item">
            <mat-label>{{ 'common.labels.middleName' | transloco }}</mat-label>
            <input matInput formControlName="middleName" data-testid="alerts-filter-middle-name">
          </mat-form-field>
          <mat-form-field class="form-field flex-item">
            <mat-label>{{ 'common.labels.lastName' | transloco }}</mat-label>
            <input matInput formControlName="lastName" data-testid="alerts-filter-last-name">
          </mat-form-field>
          <mat-form-field class="form-field flex-item">
            <mat-label>{{ 'common.labels.dateOfBirth' | transloco }}</mat-label>
            <input matInput [matDatepicker]="dateOfBirthPicker" formControlName="dateOfBirth" data-testid="alerts-filter-date-of-birth">
            <mat-datepicker-toggle matSuffix [for]="dateOfBirthPicker"></mat-datepicker-toggle>
            <mat-datepicker #dateOfBirthPicker></mat-datepicker>
          </mat-form-field>
        }
        @case (eTrackedAlertTypeEntity.Business) {
          <mat-form-field class="form-field flex-item">
            <mat-label>{{ 'common.labels.businessName' | transloco }}</mat-label>
            <input matInput formControlName="businessName" data-testid="alerts-filter-business-name">
          </mat-form-field>
          <mat-form-field class="form-field flex-item">
            <mat-label>{{ 'common.labels.businessNumber' | transloco }}</mat-label>
            <input matInput formControlName="businessNumber" data-testid="alerts-filter-business-number">
          </mat-form-field>
        }
      }
    </div>
    <div>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.clearFiltersButton' | transloco" type="button"
        (click)="onClear()" [disabled]="!_filterForm.dirty">
        {{ 'common.labels.clearFilters' | transloco }}
      </button>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.filterButton' | transloco" type="submit"
        (click)="onFilter()">
        {{ 'common.labels.filter' | transloco }}
      </button>
    </div>
  </form>
</mat-expansion-panel>
